import { FC } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Overlay from '@components/layouts/overlay/Overlay';
interface Props {
  isOpen: boolean;
  onClick: () => void;
}
const HeaderOverlay: FC<Props> = ({
  isOpen,
  onClick
}: Props) => {
  return <AnimatePresence>
            {isOpen && <motion.div initial={{
      opacity: 0,
      display: 'contents'
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.05
    }} onClick={onClick}>
                    <Overlay />
                </motion.div>}
        </AnimatePresence>;
};
export default HeaderOverlay;